export const defaultWorkOrderHeaders = [
  { key: 'id', title: 'Id', sortable: true, align: '', selectable: true },
  { key: 'name', title: 'Name', sortable: true, align: '', selectable: true },
  { key: 'order_no', title: 'Order No', sortable: true, align: '', selectable: true },
  { key: 'customer_name', title: 'Customer Name', sortable: true, align: '', selectable: true },
  { key: 'event_date', title: 'Event Date', sortable: true, align: '', selectable: true },
  { key: 'category_1_display', title: 'Category 1', sortable: true, align: '', selectable: true },
  { key: 'category_2_display', title: 'Category 2', sortable: true, align: '', selectable: true },
  { key: 'budget', title: 'Budget', sortable: true, align: '', selectable: true },
  { key: 'actions', title: 'Actions', sortable: false, width: 100, align: '', selectable: false },
]

export const defaultLineItemHeaders = [
  { key: 'action', title: 'Action', sortable: false, width: 100, align: '', selectable: false },
  { key: 'work_order__campaign__name', title: 'Project', sortable: true, align: '' , selectable: true },
  { key: 'work_order__campaign__suppliers', title: 'Suppliers', sortable: false, align: '', selectable: true },
  { key: 'line_no', title: 'Line No', sortable: true, align: '' , selectable: true },
  { key: 'work_order__order_no', title: 'SO Number', sortable: true, align: '' , selectable: true },
  { key: 'work_order_type_display', title: 'Type', sortable: true, align: '', selectable: true },
  { key: 'file_name', title: 'Filename', sortable: true, align: '' , selectable: true },
  { key: 'item_status__name', title: 'Status', sortable: true, align: '' , selectable: true },
  { key: 'responsible', title: 'Responsible', sortable: true, align: '' , selectable: true },
  { key: 'assigned_to', title: 'Assigned To', sortable: true, align: '' , selectable: true },
  { key: 'description', title: 'Description', sortable: false, align: '' , selectable: true },
  { key: 'ext_ref_num', title: 'Ext Ref #', sortable: false, align: '', selectable: true },
  { key: 'zone', title: 'Zone', sortable: true, align: ' d-none' , selectable: true },
  { key: 'zone_code', title: 'Zone Code', sortable: false, align: ' d-none' , selectable: true },
  { key: 'area', title: 'Area', sortable: true, align: ' d-none' , selectable: true },
  { key: 'area_code', title: 'Area Code', sortable: false, align: ' d-none' , selectable: true },
  { key: 'unresolved_annotations_count', title: 'Annotations', sortable: true, align: '' , selectable: true },
  { key: 'artwork_file_updated_at', title: 'Artwork Date', sortable: true, align: '' , selectable: true },
  { key: 'artwork_file', title: 'Artwork File', sortable: false, align: '' , selectable: true },
  { key: 'scope_file_updated_at', title: 'Scope Date', sortable: true, align: ' d-none' , selectable: true },
  { key: 'scope_file', title: 'Scope File', sortable: false, align: ' d-none' , selectable: true },
  { key: 'prepress_proof_file_updated_at', title: 'Prepress Proof Date', sortable: true, align: '' , selectable: true },
  { key: 'prepress_proof_file', title: 'Prepress Proof File', sortable: false, align: '' , selectable: true },
  { key: 'priority', title: 'Priority', sortable: true, align: ' d-none' , selectable: true },
  { key: 'is_on_hold', title: 'On Hold', sortable: true, align: ' d-none' , selectable: true },
  { key: 'name', title: 'Name', sortable: true, align: ' d-none' , selectable: true },
  { key: 'wo_number', title: 'WO Number', sortable: true, align: '' , selectable: true },
  { key: 'brand_book_code', title: 'Brand Book Code', sortable: true, align: '' , selectable: true },
  { key: 'cr_code_ext', title: 'Change Req Code Ext (ERP)', sortable: true, align: '' , selectable: true },
  { key: 'cr_code_int', title: 'Change Req Code Int (ERP)', sortable: true, align: '' , selectable: true },
  { key: 'supplier_erp', title: 'Supplier (ERP)', sortable: true, align: '' , selectable: true },
  { key: 'due_date', title: 'Due Date', sortable: true, align: ' d-none' , selectable: true },
  { key: 'note', title: 'Note', sortable: false, align: ' d-none' , selectable: true },
  { key: 'qty', title: 'Qty', sortable: true, align: '' , selectable: true },
  { key: 'pieces', title: 'Pieces', sortable: true, align: ' d-none' , selectable: true },
  { key: 'price', title: 'Price', sortable: true, align: ' d-none' , selectable: true },
  { key: 'total', title: 'Total', sortable: true, align: ' d-none' , selectable: true },
  { key: 'width', title: 'Width', sortable: true, align: ' d-none' , selectable: true },
  { key: 'height', title: 'Height', sortable: true, align: ' d-none' , selectable: true },
  { key: 'depth', title: 'Depth', sortable: true, align: ' d-none' , selectable: true },
  { key: 'sides', title: 'Sides', sortable: true, align: ' d-none' , selectable: true },
  { key: 'installation_photos_file_updated_at', title: 'Installation Date', sortable: true, align: ' d-none' , selectable: true },
  { key: 'installation_photos_file', title: 'Installation File', sortable: false, align: ' d-none' , selectable: true },
  { key: 'netsuite_actions_taken', title: 'Change/Additional', sortable: true, align: ' d-none', selectable: true },
  { key: 'view', title: 'View', sortable: false, width: 80, align: '', selectable: false },
]

export const defaultSignGlobalHeaders = [
  { key: 'actions', title: 'Action', sortable: false, width: 100, align: '', selectable: false },
  { key: 'campaign__name', title: 'Project', sortable: true, align: '', selectable: true },
  { key: 'campaign__suppliers', title: 'Suppliers', sortable: false, align: '', selectable: true },
  { key: 'campaign__sales_order_no', title: 'SO Number', sortable: true, align: '', selectable: true },
  { key: 'location__name', title: 'Location', sortable: true, align: '', selectable: true },
  { key: 'sign_code', title: 'Code', sortable: false, align: '', selectable: true },
  { key: 'width', title: 'Width', sortable: true, align: '', selectable: true },
  { key: 'height', title: 'Height', sortable: true, align: '', selectable: true },
  { key: 'qty', title: 'Qty', sortable: true, align: '' , selectable: true },
  { key: 'sign_price', title: 'Price', sortable: false, align: '', selectable: true },
  { key: 'sign_status__name', title: 'Status', sortable: true, align: '', selectable: true },
  { key: 'is_on_hold', title: 'On Hold', sortable: true, align: '', selectable: true },
  { key: 'priority', title: 'Priority', sortable: true, align: '', selectable: true },
  { key: 'responsible__first_name', title: 'Responsible', sortable: true, align: '', selectable: true },
  { key: 'assigned_to__first_name', title: 'Assigned To', sortable: true, align: '', selectable: true },
  { key: 'type__name', title: 'Type', sortable: true, align: '', selectable: true },
  { key: 'template_type__name', title: 'Template Type', sortable: true, align: '', selectable: true },
  { key: 'reprint_type_display', title: 'Reprint Type', sortable: true, align: '', selectable: true },
  { key: 'reprint_cost_display', title: 'Reprint Cost', sortable: true, align: '', selectable: true },
  { key: 'icon', title: 'Icon', sortable: false, align: '', selectable: true },
  { key: 'unresolved_annotations_count', title: 'Annotations', sortable: true, align: '', selectable: true },
  { key: 'artwork_file_updated_at', title: 'Artwork Date', sortable: true, align: '', selectable: true },
  { key: 'artwork_file', title: 'Artwork File', sortable: false, align: '' , selectable: true },
  { key: 'prepress_proof_file_updated_at', title: 'Prepress Proof Date', sortable: true, align: '', selectable: true },
  { key: 'prepress_proof_file', title: 'Prepress Proof File', sortable: false, align: '' , selectable: true },
  { key: 'additional_functional_areas', title: 'Functional Areas', sortable: false, align: '', selectable: true },
  { key: 'ext_ref_num', title: 'Ext Ref #', sortable: false, align: '', selectable: true },
  { key: 'notes', title: 'Supplier Notes', sortable: false, align: '', selectable: true },
  { key: 'client_notes', title: 'Client Notes', sortable: false, align: '', selectable: true },
  { key: 'fabric_notes', title: 'Notes for Fabricator', sortable: false, align: '', selectable: true },
  { key: 'instruction', title: 'Installation Instructions', sortable: false, align: '', selectable: true },
  { key: 'client_reference', title: 'Client Reference', sortable: false, align: '', selectable: true },
  { key: 'reprint_comment', title: 'Reprint Comment', sortable: false, align: '', selectable: true },
  { key: 'has_scoping_photos', title: 'Scoping Photos', sortable: false, align: '', selectable: true },
  { key: 'view', title: 'View', sortable: false, width: 80, align: '', selectable: false }
]

export const defaultKopItemGlobalHeaders = [
  { key: 'actions', title: 'Action', sortable: false, width: 100, align: '', selectable: false },
  { key: 'campaign__name', title: 'Project', sortable: true, align: '', selectable: true },
  { key: 'campaign__suppliers', title: 'Suppliers', sortable: false, align: '', selectable: true },
  { key: 'campaign__sales_order_no', title: 'SO Number', sortable: true, align: '', selectable: true },
  { key: 'location__name', title: 'Location', sortable: true, align: '', selectable: true },
  { key: 'kop_item_code', title: 'Code', sortable: false, align: '', selectable: true },
  { key: 'item_status__name', title: 'Status', sortable: true, align: '', selectable: true },
  { key: 'used_distance', title: 'Used Width', sortable: true, align: '', selectable: true },
  { key: 'height', title: 'Height', sortable: true, align: '', selectable: true },
  { key: 'qty', title: 'Qty', sortable: true, align: '' , selectable: true },
  { key: 'is_on_hold', title: 'On Hold', sortable: true, align: '', selectable: true },
  { key: 'priority', title: 'Priority', sortable: true, align: '', selectable: true },
  { key: 'responsible__first_name', title: 'Responsible', sortable: true, align: '', selectable: true },
  { key: 'assigned_to__first_name', title: 'Assigned To', sortable: true, align: '', selectable: true },
  { key: 'kop_item_type__name', title: 'Type', sortable: true, align: '', selectable: true },
  { key: 'kop_item_price', title: 'Price', sortable: true, align: '', selectable: true },
  { key: 'artwork_file_updated_at', title: 'Artwork Date', sortable: true, align: '', selectable: true },
  { key: 'artwork_file', title: 'Artwork File', sortable: false, align: '', selectable: true },
  { key: 'functional_area', title: 'Functional Area', sortable: false, align: '', selectable: true },
  { key: 'client_reference', title: 'Client Reference', sortable: false, align: '', selectable: true },
  { key: 'ext_ref_num', title: 'Ext Ref #', sortable: false, align: '', selectable: true },
  { key: 'view', title: 'View', sortable: false, width: 80, align: '', selectable: false }
]

export const defaultFinanceViewAllHeaders = [
  { key: 'action', title: 'Action', sortable: false, width: 100, align: '', selectable: false },
  { key: 'campaign_type', title: 'Type', sortable: false, align: '', selectable: true },
  { key: 'program', title: 'Program', sortable: false, align: '', selectable: true },
  { key: 'campaign', title: 'Project', sortable: false, align: '', selectable: true },
  { key: 'code', title: 'Code', sortable: false, align: '', selectable: true },
  { key: 'so_number', title: 'SO Number', sortable: false, align: '', selectable: true },
  { key: 'description', title: 'Description', sortable: false, align: '', selectable: true },
  { key: 'cr_code_ext', title: 'Change Req Code-Ext (ERP)', sortable: false, align: '', selectable: true },
  { key: 'cr_code_int', title: 'Change Req Code-Int (ERP)', sortable: false, align: '', selectable: true },
  { key: 'supplier_erp', title: 'Supplier (ERP)', sortable: false, align: '', selectable: true },
  { key: 'ext_ref_num', title: 'Ext Ref #', sortable: false, align: '', selectable: true },
  { key: 'client_reference', title: 'Client Ref #', sortable: false, align: '', selectable: true },
  { key: 'qty', title: 'Qty', sortable: false, align: '', selectable: true },
  { key: 'unit_price', title: 'Unit Price', sortable: false, align: '', selectable: true },
  { key: 'total_price', title: 'Total Price', sortable: false, align: '', selectable: true },
  { key: 'main_location', title: 'Location', sortable: false, align: '', selectable: true },
  { key: 'sign_type', title: 'Sign/Item Type', sortable: false, align: '', selectable: true },
  { key: 'workflow_status', title: 'Status', sortable: false, align: '', selectable: true },
  { key: 'is_on_hold', title: 'On Hold', sortable: false, align: '', selectable: true },
  { key: 'priority', title: 'Priority', sortable: false, align: '', selectable: true },
  { key: 'responsible', title: 'Responsible', sortable: false, align: '', selectable: true },
  { key: 'assigned_to', title: 'Assigned To', sortable: false, align: '', selectable: true },
  { key: 'view', title: 'View', sortable: false, width: 80, align: '', selectable: false },
]

export const defaultChangeRequestViewAllHeaders = [
  { key: 'expand', title: 'Expand', sortable: false, width: 70, align: '', selectable: false },
  { key: 'name', title: 'Name', sortable: true, align: '', selectable: true  },
  { key: 'code', title: 'Code', sortable: true, align: '', selectable: true  },
  { key: 'created', title: 'Date & Time', sortable: true, align: '', selectable: true  },
  { key: 'requestor', title: 'Requestor Name', sortable: true, align: '', selectable: true  },
  { key: 'requestor__email', title: 'Requestor Email', sortable: true, align: '', selectable: true  },
  { key: 'status', title: 'Status', sortable: true, align: '', selectable: true  },
  { key: 'priority', title: 'Priority', sortable: true, align: '', selectable: true  },
  { key: 'assigned_to', title: 'Assigned To', sortable: true, align: '', selectable: true  },
  { key: 'suppliers', title: 'Suppliers', sortable: true, align: '', selectable: true  },
  { key: 'supplier_cost', title: 'Supplier Cost', sortable: false, align: '', selectable: true  },
  { key: 'cost_estimate_approval_amount', title: 'Cost Estimate Approval Amount', sortable: false, align: '', selectable: true  },
  { key: 'request_type', title: 'Change Request Type', sortable: true, align: '', selectable: true  },
  { key: 'project_type', title: 'Type of Project', sortable: true, align: '', selectable: true  },
  { key: 'category_2', title: 'Category 2', sortable: true, align: '', selectable: true  },
  { key: 'project__name', title: 'Project', sortable: true, align: '', selectable: true  },
  { key: 'project__event_group__name', title: 'Program', sortable: true, align: '', selectable: true  },
  { key: 'qty', title: 'Quantity', sortable: true, align: '', selectable: true  },
  { key: 'sales_order_name', title: 'Sales Order', sortable: true, align: '', selectable: true  },
  { key: 'item_code', title: 'Item Code', sortable: true, align: '', selectable: true  },
  { key: 'reason_for_change', title: 'Reason for Change', sortable: true, align: '', selectable: true  },
  { key: 'details', title: 'Details', sortable: true, align: '', selectable: true  },
  { key: 'description', title: 'Description', sortable: true, align: '', selectable: true  },
  { key: 'client_reference', title: 'Client Reference', sortable: true, align: '', selectable: true  },
  { key: 'services_required', title: 'Services Required', sortable: true, align: '', selectable: true  },
  { key: 'due_date', title: 'Due Date', sortable: true, align: '', selectable: true  },
  { key: 'file_attachments', title: 'File Attachments', sortable: false, align: '', selectable: true  },
  { key: 'view', title: 'View', sortable: false, width: 80, align: '', selectable: false }
]

export const COLUMN_TYPE_BRANDING = 'branding' as const
export const COLUMN_TYPE_WAYFINDING = 'wayfinding' as const
export const COLUMN_TYPE_KOP = 'kop' as const

export type ColumnType =
  | typeof COLUMN_TYPE_BRANDING
  | typeof COLUMN_TYPE_WAYFINDING
  | typeof COLUMN_TYPE_KOP

export type TableHeader = {
  key: string
  title: string
  selectable?: boolean
  [key: string]: unknown
}

export const systemColumnKeys = ['action', 'actions', 'view']

export const isUserSelectableHeader = (header: TableHeader) =>
  header.selectable !== false && !systemColumnKeys.includes(header.key)

export const filterHeadersByAllowedColumnKeys = (headers: TableHeader[], allowedColumnKeys?: string[]) => {
  if (allowedColumnKeys === undefined)
    return headers

  const allowedColumnKeySet = new Set(allowedColumnKeys)

  return headers.filter(header =>
    !isUserSelectableHeader(header) || allowedColumnKeySet.has(header.key),
  )
}
